/*
 * Errors caught by ErrorBoundary components when a GraphQL
 * query fails to respond within the alloted time.
 *
 * Note that this is a partial schema, see GraphQL error
 * payloads for the full form.
 *
 * ref: https://www.apollographql.com/docs/react/data/error-handling#graphql-errors
 */
export interface GraphQLError extends Error {
	source: {
		errors: Array<{ timeout: boolean }>;
	};
}

// Server may return 429 (Too Many Requests) for personal workspaces
// We use this error to properly handle the rate limit error
export class RateLimitError extends Error {}

// Server may return 504 (Gateway Timeout)
// We use this error to properly handle the gateway timeout error
// Even if the main reason is a Mysql timeout, the gateway timeout might raise first
export class GatewayTimeoutError extends Error {}
